export class ArtifactView
{
    public readonly type:any;
    public readonly descriptor:string;
    public readonly name:string;
    public readonly repositories:string[];

    constructor(json:any)
    {
        this.type = json['type'];
        this.descriptor = json['descriptor'];
        this.name = json['name'];
        this.repositories = [];
        for( let i = 0, length = (json['repositories'] || []).length; i < length; i++ )
        {
            this.repositories.push(json['repositories'][i]);
        }
    }
}
